
import { Injectable } from '@angular/core';
import { NotificationsService as NotificationAngularService } from 'angular2-notifications';
// import Swal, { SweetAlertResult } from 'sweetalert2';
@Injectable({
  providedIn: 'root'
})
export class NotificationAlertService {
  // toast = Swal.mixin({
  //   toast: true,
  //   position: 'top-end',
  //   showConfirmButton: false,
  //   showCloseButton: true,
  //   timer: 5000,
  //   timerProgressBar: true,
  //   didOpen: (toast: { addEventListener: (arg0: string, arg1: any) => void; }) => {
  //     toast.addEventListener('mouseenter', Swal.stopTimer)
  //     toast.addEventListener('mouseleave', Swal.resumeTimer)
  //   }
  // })

  constructor(
    private _notificationsService: NotificationAngularService
  ) { }

  confirm(options?: {
    title?: string;
    text?: string;
    confirmButtonText?: string;
    icon?: string;
    cancelButtonText?: string;
    showCancelButton?: boolean;
  }): Promise<any> {
    let title = options.title ?? 'Atenção';
    let text = options.text ?? 'Deseja realmente confirma a ação?';
    let confirmButtonText = options.confirmButtonText ?? 'Sim';
    let icon = options.icon ?? 'warning';
    let cancelButtonText = options.cancelButtonText ?? 'Não';
    let showCancelButton = options.showCancelButton ?? true;

    return Promise.resolve(true)
    // return Swal.fire({
    //   title,
    //   html: text,
    //   icon,
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonColor: '#d33',
    //   showCancelButton,
    //   confirmButtonText,
    //   cancelButtonText
    // })
    // .then((result) => {
    //   if (result.isConfirmed) {
    //     Swal.fire(
    //       'Deleted!',
    //       'Your file has been deleted.',
    //       'success'
    //     )
    //   }
    // })

  }



  alert(message: any, title?: string) {
    this._notificationsService.alert(title, message);
    // this.toast.fire({
    //   icon: 'success',
    //   // title: 'Signed in successfully',
    //   title: message
    // })
  }
  success(message: any, title?: string) {
    this._notificationsService.success(title, message);
    // this.toast.fire({
    //   icon: 'success',
    //   // title: 'Signed in successfully',
    //   title: message
    // })
  }
  info(message: any, title?: string) {
    this._notificationsService.info(title, message);
    // this.toast.fire({
    //   icon: 'info',
    //   // title: 'Atenção!',
    //   title: message
    // })
  }
  error(message: any, title?: string) {
    this._notificationsService.error(title, message);
    // this.toast.fire({
    //   icon: 'error',
    //   // title: 'Ou! Ou!',
    //   title: message
    // })
  }
  warning(message: any, title?: string) {
    this._notificationsService.warn(title, message);
    // this.toast.fire({
    //   icon: 'warning',
    //   // title: 'Opps!',
    //   title: message
    // })
  }



}
